import { appSettings } from "core/config";
import BaseCefCommercialService from "./base.service";
import { CefVersion } from "./constants";

// {
//     "sendRequestDetail": {
//         "algorithm": "GTdJaGOelp",
//         "audience": "",
//         "deliver": true,
//         "delivery": [
//             {
//                 "encryptedValue": "bBcC",
//                 "key": "DccYSlsyD",
//                 "mode": "hKRkeqTJXbm",
//                 "senderId": "cYG",
//                 "value": "ALGsJsmFV"
//             }
//         ],
//         "expiry": 495781122,
//         "length": 410241201,
//         "passwordType": "UIigKYxws",
//         "source": "bMIcmr"
//     }
// }

const otpOptions = {
    algorithm: "basic",
    audience: "DStv Business",
    source: "DStv Business",
    expiry: 120,
    length: 4,
    passwordType: "numeric"
}

export type OtpDeliveryRequest = {
    encryptedValue: string,
    key: string,
    mode: "sms" | "email"
}

type OtpDeliveryOptions = OtpDeliveryRequest & {
    senderId: string
}

type OtpRequest = {
    algorithm: string,
    audience: string,
    source: string,
    expiry: number,
    length: number,
    passwordType: string, //"numeric" | "alphanumeric" | "alpha"
    delivery: OtpDeliveryOptions[],
    deliver?: boolean
}

class OtpService extends BaseCefCommercialService {
    constructor() {
        super("");
        this.setBaseUrl(`CEFOTPAPI/${CefVersion}`);
    }

    sendAsync(options: OtpDeliveryRequest) {
        const senderIds = appSettings.senderIds.find(x => x.countryCode === this.countryCode.toLowerCase());

        const senderId = options.mode === "sms" ? senderIds?.sms : senderIds?.email;

        const request: OtpRequest = {
            algorithm: otpOptions.algorithm,
            audience: otpOptions.audience,
            //deliver: environment.production,
            source: otpOptions.source,
            expiry: otpOptions.expiry,
            length: otpOptions.length,
            passwordType: otpOptions.passwordType,
            delivery: [
                {
                    encryptedValue: options.encryptedValue,
                    key: options.key,
                    mode: options.mode,
                    senderId: senderId ?? ""
                }
            ]
        };

        const payload = {
            sendRequestDetail: request
        }
        return this.createPromiseRequest("otp/send").post<any>(payload);
    }
}

export default OtpService;
